import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import ListView from "@/components/AntListView";

/**
 * @description 江苏文交所二期
 * @return {/culturalExchange_gold/collectionRecord}
 */

const CollectionRecord = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([])
  const [hasMore, setHasMore] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(10);

  useEffect(() => {
    (()=>{
      getData(true);
    })()

  }, []);

  const getData = async (loading = false, isRefresh = true) => {
    try {
      if (loading) showLoading();
      
      if (isRefresh) {
        currentPage.current = 1;
      } else {
        currentPage.current = currentPage.current + 1;
      }
      
      const res = await Service.getRecordsData(currentPage.current);
      if (loading) hideLoading();
      if(res?.data?.records?.length > 0){
        const newList = res.data.records || [];
        if (currentPage.current === 1) {
          setRecords(newList);
        } else {
          setRecords([...records, ...newList]);
        }
        console.log('newList===>', newList)
        setIsLoad(true);
        setHasMore(newList.length >= pageSize.current);
      } else {
        setIsLoad(true);
        setHasMore(false);
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const loadMore = async () => {
    await getData(false, false);
  }

  const onRefresh = async () => {
    await getData(false, true);
  }

  const RecordItem = (item, index) => {
    return (
      <div 
        key={item.id} 
        className={Styles.recordCard}
      >
        <div className={Styles.itemInfo}>
          <div className={Styles.itemName}>
            {item.productName} x{item.desc}
          </div>
          <div className={Styles.timestamp}>
            {item.createTime}
          </div>
        </div>
        <div className={Styles.line}></div>
        <div 
          className={Styles.viewOrder}
          onClick={() => handleViewOrder(item)}
        >
          查看订单
        </div>
      </div>
    )
  }

  const handleViewOrder = (item) => {
    console.log('查看订单:', item)
    // 这里可以添加跳转到订单详情的逻辑
    const param = objectToQueryParams({
      id: item?.id,
      phone: item?.phone,
      prizeImgUrl: item?.productImgUrl,
      prizeName: item?.productName,
      prizeType: item?.productType,
      // skuId: item?.goodsId, //没有看出来有啥用
      createTime: item?.createTime,
      consigneeName: item?.consigneeName,
      consigneeNumber: item?.consigneeNumber,
      province: item?.province,
      city: item?.city,
      area: item?.area,
      street: item?.street,
      address: item?.address,
      deliverStatus:item?.deliverStatus,
      deliverGoods:item?.deliverGoods||0,
        logCo:item?.logCo||"",
        trackNo:item?.trackNo||"",
        shipDate:item?.shipDate||"",
        orderId:item?.orderId||"",
        needShowCount:item?.desc,
    });
    window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
  }

  const handleBack = () => {
    // if (window.JsBridge.hasWebViewBridge()) {
    //     window.JsBridge.back();
    //   } else {
    //     navigate(-1);
    //   }
      navigate(-1);
  }

  return (
    <div className={Styles.collectionRecord}>
      {/* 状态栏 */}
      <div className={Styles.statusBar}>
      </div>

      {/* 导航栏 */}
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}>
        </div>
        <div className={Styles.title}>领取记录</div>
        <div className={Styles.placeholder}></div>
      </div>

      {/* 内容区域 */}
      <div className={Styles.content}>
        <ListView
          dataSource={records}
          hasMore={hasMore}
          renderItem={RecordItem}
          onRefresh={onRefresh}
          onEndReached={loadMore}
          isLoad={isLoad}
          emtyDesc="暂无领取记录"
        />
      </div>
    </div>
  )
}

export default CollectionRecord
